import type { BinColor } from '../constants';

/** Confidence in reading the scan, independent of correctness or marking confidence. */
export const MIN_SCAN_CONFIDENCE = 0.5;

export function answerReviewMessage(reason: string): string {
  return reason === 'low_scan_confidence'
    ? 'We could not read your scan confidently. Your answer is flagged for your teacher and has not been graded. You can continue with the other questions.'
    : 'Your answer is flagged for your teacher and has not been graded. You can continue with the other questions.';
}

export interface AnswerReviewDTO {
  id: string;
  studentPaperId: string;
  questionId: string;
  studentName: string;
  paperTitle: string;
  questionNumber: number;
  questionText: string;
  submittedAnswer: string | null;
  hasScan: boolean;
  scanConfidence: number | null;
  reviewReason: string;
  attemptIndex: number;
  maxMarks: number;
  teacherBin: BinColor | null;
  resolutionState: 'waiting' | 'active' | 'failed' | null;
  createdAt: string;
}
/** Shared by the automatic ladder and the teacher's marks preview. */
const MARKS_MULTIPLIER: Record<BinColor, number> = {
  GREEN: 1,
  PURPLE: 1,
  BLUE: 0.5,
  ORANGE: 0.25,
  PINK: 0,
};

export function marksForBin(bin: BinColor, maxMarks: number): number {
  return Math.round(maxMarks * MARKS_MULTIPLIER[bin] * 100) / 100;
}

export interface ResolveAnswerReviewResponse {
  jobId: string;
  resolved: boolean;
}
